// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.Users__scroll-bb5dc9 {
  flex: 1;
  overflow: auto;
}`, "",{"version":3,"sources":["webpack://./src/components/SelectContacts/Users/Users.styles.m.css"],"names":[],"mappings":"AAAA;EACE,OAAA;EACA,cAAA;AACF","sourcesContent":[".scroll {\n  flex: 1;\n  overflow: auto;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"scroll": `Users__scroll-bb5dc9`
};
module.exports = ___CSS_LOADER_EXPORT___;
